import { ReactNode, useRef } from 'react'
import { View } from 'tamagui'
import { useOnVisible } from '@hooks/useOnVisible'

export interface ILoadMoreSentinelProps {
  onVisible: () => void
  /** Desliga o observer quando não há mais páginas. */
  enabled?: boolean
  /** Muda a cada página anexada para re-armar o observer. */
  resetKey?: unknown
  rootMargin?: number
  children?: ReactNode
  testID?: string
}

/**
 * Marca o fim de uma lista paginada e avisa quando esse fim aparece na tela.
 * Na web usa o IntersectionObserver do browser (ver `useOnVisible`); no native,
 * o InView de react-native-intersection-observer (LoadMoreSentinel.native.tsx).
 */
export function LoadMoreSentinel({
  onVisible,
  enabled = true,
  resetKey,
  rootMargin,
  children,
  testID,
}: ILoadMoreSentinelProps) {
  const ref = useRef<Element | null>(null)

  useOnVisible(ref, onVisible, { enabled, resetKey, rootMargin })

  // width/height obrigatórios: um alvo de área zero nunca intersecta, então o
  // IntersectionObserver reportaria isIntersecting=false para sempre. Dentro de
  // um grid flexWrap, width 100% ainda garante que a sentinela caia numa linha
  // própria abaixo dos cards em vez de ser espremida ao lado deles.
  return (
    <View ref={ref as never} testID={testID} width="100%" minHeight={1}>
      {children}
    </View>
  )
}
